import React from "react";
import {Col, Row} from "react-bootstrap";
import BizLocationSelector from "../BizLocation/BizLocationSelector";
import ProductTypeSelector from "../../productType/component/ProductTypeSelector";
import moment from "moment";
import DateSelector from "../Date/DateSelector";

class MovementOrderByTransactionFilter extends React.Component {

  state = {};

  constructor(props) {
    super(props);
  }

  componentDidMount() {
    const {location, onChange} = this.props;
    const windowFilter = Object.fromEntries(new URLSearchParams(location.search));

    const {bizLocationOutId, bizLocationOutName, bizLocationInId, bizLocationInName, productTypeId, productTypeReferenceOrFriendlyName, date} = windowFilter;
    const newFilters = {ready: true};

    if (bizLocationOutId) {
      newFilters.bizLocationOut = {id: bizLocationOutId, friendlyName: bizLocationOutName};
    }

    if (productTypeId) {
      newFilters.productType = {id: productTypeId, referenceOrFriendlyName: productTypeReferenceOrFriendlyName};
    }

    if (bizLocationInId) {
      newFilters.bizLocationIn = {id: bizLocationInId, friendlyName: bizLocationInName}
    }

    if (date) {
      const [year, month, day] = date.split('-')
      newFilters.date = new Date(year, month - 1, day)
    }

    this.setState({newFilters});
    onChange(newFilters);
  }

  render() {
    const {onChange} = this.props;
    const {newFilters} = this.state;
    if (!newFilters) {
      return false;
    }
    return (
        <Row>
          <Col lg={3}>
            <BizLocationSelector
                title="Local Origem"
                defaultValue={newFilters.bizLocationOut}
                onChange={value => {
                  onChange({bizLocationOut: value});
                }}/>
          </Col>
          <Col lg={3}>
            <BizLocationSelector
                title="Local Destino"
                defaultValue={newFilters.bizLocationIn}
                onChange={value => {
                  onChange({bizLocationIn: value});
                }}/>
          </Col>
          <Col lg={3}>
            <ProductTypeSelector title="Tipo de Produto"
                                 defaultValue={newFilters.productType}
                                 onChange={value => {
                                   onChange({productType: value});
                                 }}/>
          </Col>
          <Col lg={3}>
            <DateSelector title="Data da transação"
                                 defaultValue={newFilters.date && moment(newFilters.date).format('YYYY-MM-DD')}
                                 onChange={date => {
                                  onChange({ date: moment(date).format('YYYY-MM-DD') })
                                 }}/>
          </Col>
        </Row>
    );

  }

}

export default MovementOrderByTransactionFilter;



// WEBPACK FOOTER //
// ./src/component/Filter/MovementOrderByTransactionFilter.js